<template>
    <div class="page_content container-fluid" aria-label="Tag Configuration">
        <div class="row page-heading">

            <div class="col-8 input module_heading" role="heading" aria-level="1">
                <span class="module_icon ic-tag"></span>
                <!--<label class="head_txt module_type_name institution-title ace_sec_hd">{{institution.displayName}}<span class="ml-3">></span><span class="ml-3">Tag Types</span></label>-->
                <label class="head_txt module_type_name institution-title ace_sec_hd">
                    Tag Configuration <span class="ml-3">></span><span class="ml-3">Tag Types</span>
                </label>
            </div>

            <div class="col-4 btn_container">
                <span class="float-right ml-3">
                    <button type="button" class="btn btn-primary" aria-label="new" @click="newTagType" :disabled="permission && permission.systemPermission && permission.systemPermission.readOnly">new</button>
                </span>
            </div>

        </div>

        <div class="row">
        	<!--
            <div cols="3" class="facets ace_sec">
                <div class="main-head text-center">
                    <span class="head_txt" role="heading" aria-lavel="1">Narrow Results</span>
                </div>
                <div class="main-head text-center" style="background: none;">
                    <span class="head_txt" role="heading" aria-lavel="1">type to search results</span>
                </div>
            </div>
            -->

            <div class="col-12 datatable" style="margin-left: 15px; padding-top: 20px;">
                <b-row class="search_result_container" style="width: calc(100% - 1px); height: calc(100vh - 228px);">
                    <b-col cols="11">
                        <b-list-group>
                            <template v-if="isResultLoaded && (results.length === 0)">
                                <div class="msg_no_result">
                                    No results found!
                                </div>
                            </template>
                            <template v-else>
                                <b-list-group-item class="flex-column align-items-start result_row" v-for="(result, index) in results">
                                    <div :key="result.uuid">
                                        <!--
                                        <div class="facet_list">
                                            <div class="checkbox">
                                                <span class="form-checkbox">
                                                    <input type="checkbox" :aria-labelledby="'tag_setting_' + index" :value="result.uuid" :disabled="(isSystemGeneratedTagCategory(result) || permission.systemPermission.readOnly)" v-model="selectedUuids" @change="toggleCheckbox($event, result)">
                                                </span>
                                            </div>
                                        </div>
                                        -->
                                        <div class="result_block" style="width: calc(100% - 1px);">
                                            <div class="d-flex w-100">
                                                <div class="title col-2" :id="'tag_setting_' + index" :title="result.displayValue">{{result.displayValue}}</div>
                                                <div class="col-9">{{generateTagSettingText(result)}}</div>
                                                <div class="col-1 btn_container" style="min-width: 102px;">
                                                  <b-btn aria-label="Edit" class="btn_ic edit" :disabled="permission.systemPermission.readOnly" @click="editTagSetting(result)">
                                                    <span class="ic icon-edit"></span>
                                                  </b-btn>
                                                  <b-btn aria-label="Edit" class="btn_ic delete-icon" @click="showDeleteTagTypeConfirm(result)">
                                                    <i class="ic icon-bin" aria-hidden="true" :disabled="permission.systemPermission.readOnly"></i>
                                                  </b-btn>
                                                </div>
                                            </div>
                                            <div class="mt-1 mb-3">
                                                <div class="col-2 float-left" style="padding-left: 0px !important;">Tags</div>
                                                <div class="col-10 float-right">
                                                  <div class="tags_container2">
                                                    <div class="tags_container_inner">
                                                      <span class="tag" v-for="(data, index) in result.adminDefined" v-bind:title="data.tag.name" v-bind:aria-label="data.tag.name">
                                                          <span class="tag_name"> {{ data.tag.name }} </span>
                                                      </span>
                                                    </div>
                                                  </div>
                                                  <!--
                                                  <template v-if="enableShowMoreLink">
                                                    <div class="show_more_link">
                                                      <a href="javascript:void(0);" @click="showAllTags()">show more</a>
                                                    </div>
                                                  </template>
                                                  <template v-if="enableShowLessLink">
                                                    <div class="show_more_link">
                                                      <a href="javascript:void(0);" @click="showLessTags()">show less</a>
                                                    </div>
                                                  </template>
                                                -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </b-list-group-item>
                            </template>
                        </b-list-group>
                    </b-col>
                </b-row>
            </div>
        </div>

        <div class="loading-spinner">
            <b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
                <div class="text-center" style="color: #FFF">
                    <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
                </div>
            </b-modal>
        </div>

        <div class="modal_container modal_alart confirm">
            <b-modal class="delete-folder-popup" ref="deleteTagTypeConfirmModal" :header-bg-variant="'discover-content-delete-modal'" no-close-on-backdrop no-close-on-esc centered>
                <div style="text-align: center;">
                    <h6 v-html="deleteTagTypeMessage"></h6>
                </div>
                <div slot="modal-header" class="header-section">
                  <div class="ic ic-hd"></div>
                  <div class="head_txt">Deleting Tag Type</div>
                  <button type="button" class="btn_close" @click="cancelDelete" aria-label="close">
                    <span class="ic-close"></span>
                  </button>
                </div>
                <div slot="modal-footer" class="w-100">
                    <b-button @click="deleteSelected" class="btn button-primary next float-right mr-2" aria-label="yes"> yes </b-button>
                    <b-button @click="cancelDelete" class="btn button-primary next float-right mr-2" aria-label="no"> no </b-button>
                </div>
            </b-modal>
        </div>

    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex'

    export default {
      name: 'tag-configuration',
      data: () => {
        return {
          results: [],
          selectedUuids: [],
          selectedObjects: [],
          isResultLoaded: false,
          existingTagCategories: [],
          deleteTagTypeMessage: '',
          matchAtLeastOneInTags: [],
          deleteTagTypeEntityCount: 0,
          entityTypeAndUuidMapping: {},
          enableShowMoreLink: true,
          enableShowLessLink: false,
          libraryList: localStorage.getItem('user_personal_LS_UUID'),
          indexList: ['deliverycontext', 'learningcontent', 'learningtopic', 'stream', 'job', 'catalog', 'event', 'club', 'person']
        }
      },

      mounted () {
        this.showLoader()
        this.loadPublicInstitutionDetail().then(res => {
          if (res) {
            this.loadTagTypes(res.uuid)
          } else {
            this.isResultLoaded = true
            this.hideLoader()
          }
        })
      },

      methods: {
        ...mapActions([
          'loadPublicInstitutionDetail',
          'loadTagSettings',
          'constructSearchQuery',
          'deleteTagSettings',
          'loadDeleteTagsFromEntity'
        ]),

        loadTagTypes (institutionId) {
          this.loadTagSettings(institutionId).then(data => {
            /*
            this.results = data.content.filter((result) => {
              return ((result.category === 'general') || (result.category.indexOf('custom_') !== -1))
            })
            */
            this.results = data.content
            this.populateExistingTagCategories(this.results)
            this.isResultLoaded = true
            this.hideLoader()
          })
        },

        showAllTags () {
          this.enableShowMoreLink = false
          this.enableShowLessLink = true
          $('.tags_container2').addClass('show_all_tags')
        },

        showLessTags () {
          this.enableShowMoreLink = true
          this.enableShowLessLink = false
          $('.tags_container2').removeClass('show_all_tags')
        },

        isSystemGeneratedTagCategory (result) {
          return (result && (result.category.indexOf('custom_') === -1))
        },

        generateTagSettingText (result) {
          let text = 'not exposed to users and '
          if (result && result.exposedToUser.optionSelected === 'yes') {
            text = 'exposed to users and '
          }
          let granularityArr = result.granularity.optionSelected
          if (granularityArr.length > 0) {
            text = text + 'tags allowed for ' + granularityArr.join(', ')
          } else {
            text += 'no tags allowed'
          }
          return text.toLowerCase()
        },

        generateAllTagList (result) {
          let tags = (result) ? [...result.pragyaDefined, ...result.adminDefined] : []
          return tags
        },

        populateExistingTagCategories (results) {
          results.forEach((tagType) => {
            let category = tagType.category
            this.existingTagCategories.push({'category': category, 'displayValue': tagType.displayValue.toLowerCase()})
          })
        },

        toggleCheckbox (ev, item) {
          this.selectedObjects.push(item)
        },

        showLoader () {
          if (this.$refs.loadingModal) {
            this.$refs.loadingModal.show()
          }
        },

        hideLoader () {
          if (this.$refs.loadingModal) {
            this.$refs.loadingModal.hide()
          }
        },

        showDeleteTagTypeConfirm (result) {
          this.showLoader()
          this.selectedUuids = []
          this.deleteTagTypeEntityCount = 0
          this.selectedUuids.push(result.uuid)
          this.deleteTagTypeMessage = 'Do you want to delete this Tag Type and all its Tags?'
          this.matchAtLeastOneInTags = []
          result.adminDefined.forEach((item) => {
            this.matchAtLeastOneInTags.push({tagValue: item.tag.name, category: result.category})
          })
          this.constructSearchQuery({matchAtLeastOneInTags: this.matchAtLeastOneInTags, pageNumber: 1, from: 0, indexList: this.indexList, libraryList: this.libraryList}).then(res => {
            if (res && res.hits) {
              this.deleteTagTypeEntityCount = res.hits.total
              if (this.deleteTagTypeEntityCount > 0) {
                if (this.deleteTagTypeEntityCount > 1) {
                  this.deleteTagTypeMessage = 'There are ' + this.deleteTagTypeEntityCount + ' entities associated with this Tag Type.<BR><BR>' + this.deleteTagTypeMessage
                } else {
                  this.deleteTagTypeMessage = 'There is 1 entity associated with this Tag Type.<BR><BR>' + this.deleteTagTypeMessage
                }
              }
            }
            this.hideLoader()
            this.$refs.deleteTagTypeConfirmModal.show()
            if (res && res.hits && res.hits.hits) {
              let results = res.hits.hits
              results.forEach(result => {
                let enityType = (result._index === 'stream') ? 'entity' : result._index
                let uuid = result._source.uuid
                if (this.entityTypeAndUuidMapping.hasOwnProperty(enityType)) {
                  this.entityTypeAndUuidMapping[enityType].push(uuid)
                } else {
                  this.entityTypeAndUuidMapping[enityType] = [uuid]
                }
              })
            }
          })
        },

        deleteSelected () {
          this.$refs.deleteTagTypeConfirmModal.hide()
          this.showLoader()
          this.deleteTagSettings(this.selectedUuids).then(res => {
            if (res) {
              if (res.succeeded > 0) {
                let keys = Object.keys(this.entityTypeAndUuidMapping)
                if (keys.length > 0) {
                  let categoryToBeDeleted = {category: this.matchAtLeastOneInTags[0].category, tagValue: []}
                  keys.forEach(entity => {
                    let uuids = this.entityTypeAndUuidMapping[entity]
                    let url = entity + '/deleteTagsFromEntity?uuids=' + uuids
                    this.loadDeleteTagsFromEntity({url: url, categoryToBeDeleted: categoryToBeDeleted})
                  })
                }
                let message = '' + res.succeeded + ' Tag Type deleted successfully.'
                setTimeout(() => {
                  this.$notify({
                    group: 'notify',
                    type: 'success',
                    title: '',
                    text: message
                  })
                }, 0)
              }
              if (res.unauthorized > 0) {
                let message = '' + res.unauthorized + ' Tag Type not deleted due to lack of permission.'
                setTimeout(() => {
                  this.$notify({
                    group: 'notify',
                    type: 'warn',
                    title: '',
                    text: message
                  })
                }, 500)
              }
            } else {
              this.$notify({
                group: 'notify',
                type: 'error',
                title: '',
                text: 'Tag Type deletion failed due to a network issue.'
              })
            }
            setTimeout(() => {
              this.resetSelectedTagsInTagType()
              this.loadTagTypes(this.institution.uuid)
            }, 1000)
          })
          this.selectedUuids = []
        },

        cancelDelete () {
          this.$refs.deleteTagTypeConfirmModal.hide()
          this.selectedUuids = []
          this.deleteTagTypeEntityCount = 0
          this.resetSelectedTagsInTagType()
        },

        resetSelectedTagsInTagType () {
          this.deleteTagTypeMessage = ''
          this.matchAtLeastOneInTags = []
          this.entityTypeAndUuidMapping = {}
          this.$store.commit('LOAD_MATCH_AT_LEAST_ONE', [])
        },

        editTagSetting (result) {
          return this.$router.push({name: 'editTagType', params: {uuid: result.uuid, data: result, existingTagCategories: this.existingTagCategories}})
        },

        newTagType () {
          return this.$router.push({name: 'createTagType', params: {institutionId: this.institution.uuid, existingTagCategories: this.existingTagCategories}})
        }
      },

      computed: {
        ...mapState({
          'institution': state => state.institution.publicInstitution,
          'permission': state => state.user.permission
        })
      }
    }
</script>

<style scoped>
    .facets {
        margin-left: 15px;
    }
    .main-head {
      background: #bee4e6;
      padding: 12px 0;
      float: left;
      width: 100%;
      border-bottom: 2px solid #fff;
    }
    .module_type_name {
      cursor: default !important;
    }
    .datatable {
      width: calc(100% - 370px) !important;
    }
    .title {
      cursor: default !important;
      padding-left: 0px !important;
    }
    .tags_container2 {
      max-height: 190px;
      overflow-y: auto;
    }
    .show_all_tags {
      max-height: auto;
      overflow-y: visible;
    }
    .show_more_link {
      float: right;
      text-align: right;
      width: 80%;
      margin-top: 8px;
      padding-bottom: 10px;
      margin-right: 5px;
    }

</style>



// WEBPACK FOOTER //
// src/app/tagging/components/TagConfiguration.vue